module.exports = __webpack_public_path__ + "static/media/css.4d785e94.svg";